<div appTheme>
    <div class="footer">
        <div class="row footer-row" [ngClass]="{'blur-background': blurBackground}">

            <div class="footer-links col-lg-8">
                <ul *ngIf="!isUnAuthenticatedRoute" class="list-inline">
                    <li><a (click)="onShowDocument(DocumentType.About)">About</a></li>
                    <li><a (click)="onShowDocument(DocumentType.Support)">Support</a></li>
                    <li><a (click)="onShowDocument(DocumentType.TermsOfService)">Terms</a></li>
                    <li><a (click)="onShowDocument(DocumentType.PrivacyPolicy)">Privacy</a></li>
                </ul>
                <div class="copyright">
                    <span>© {{currentYear}} <a href="http://www.toro.com">The Toro Company</a>. All rights reserved.
                    </span>
                    <span class="footer-version">v{{ version }}</span>
                    <span *ngIf="showApiEndpoint" id="footer-endpoint">(API Endpoint: {{ apiEndpointUrl }} -
                        v{{apiVersion}})</span>
                </div>
            </div>

            <div class="company-logos col-lg-4">
                <img id="logo-image" src="../../../assets/images/Toro-Irritrol-ULS-Logos-inverted.png" usemap="#logomap"
                    hidefocus="true">

                <map name="logomap">
                    <area shape="rect" [coords]="getImageMapCoordinates('toro')" href="http://www.thetorocompany.com/"
                        target="_blank" alt="The Toro Company Logo">
                    <area shape="rect" [coords]="getImageMapCoordinates('irritrol')" href="http://www.irritrol.com/"
                        target="_blank" alt="The Toro Company Logo">
                    <area shape="rect" [coords]="getImageMapCoordinates('uniquelighting')"
                        href="http://www.uniquelighting.com/" target="_blank" alt="The Toro Company Logo">
                </map>
            </div>

        </div>
    </div>
</div>
